export const USERS_STATUS_ENABLED = "ENABLED";
export const USERS_STATUS_DISABLED = "DISABLED";

export const USERS_STATUSES = [USERS_STATUS_ENABLED, USERS_STATUS_DISABLED];

export const USERS_DRESO = "dreso.com";

